// 결투장식 KO 화면(docs/analysis/DUELING-GROUNDS.md): 결정타 순간 화면을 어둡고 붉게 누르고, 가장자리 진홍 테두리와 집중선을 짧게 건다.
// 실제 시간(realMs)으로 흐른다(히트스톱 중에도 들어온다). 밝게 번쩍이는 섬광이 아니라 어둡게 하는 연출이라 섬광 리미터 대상이 아니다.
import { KO_SCREEN } from '../shared/config';
import type { PostFx } from '../render/post';

export class KoScreen {
  private start = -1e9;
  private amp = 0;
  /** QA: 발동 수 */
  fired = 0;

  constructor(private readonly post: PostFx) {}

  /** strength: 설정 '전투 연출' 배율(0이면 걸지 않는다, 1 초과는 1) */
  trigger(nowMs: number, strength: number): void {
    const s = Math.max(0, Math.min(1, strength));
    if (s <= 0) return;
    this.start = nowMs;
    this.amp = s;
    this.fired++;
  }

  /** 지금 세기(0..1): 들어오기 → 유지 → 나가기 */
  value(nowMs: number): number {
    const t = nowMs - this.start;
    const { inMs, holdMs, outMs } = KO_SCREEN;
    if (t < 0 || t >= inMs + holdMs + outMs) return 0;
    if (t < inMs) return this.amp * (t / inMs);
    if (t < inMs + holdMs) return this.amp;
    const u = (t - inMs - holdMs) / outMs;
    return this.amp * (1 - u * u * (3 - 2 * u));
  }

  update(nowMs: number): void {
    const k = this.value(nowMs);
    this.post.ko.value = k * KO_SCREEN.dark;
    this.post.koLines.value = k * KO_SCREEN.lines;
  }

  reset(): void {
    this.start = -1e9;
    this.amp = 0;
    this.post.ko.value = 0;
    this.post.koLines.value = 0;
  }
}
